import { openBlock, createElementBlock, normalizeClass, pushScopeId, popScopeId, createElementVNode } from "vue";
/* empty css                  */
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-arrow-icon",
  props: {
    type: {
      type: String,
      validator(value) {
        return ["right", "default", "down", "left", "up"].includes(value);
      },
      default: "default"
    },
    gradient: {
      type: String,
      validator(value) {
        return ["gradient", "no-gradient"].includes(value);
      },
      default: "gradient"
    }
  },
  computed: {
    arrowIconClass() {
      return {
        [`uikit-arrow-icon-${this.type}`]: true,
        [`uikit-arrow-icon-${this.gradient}`]: true
      };
    }
  }
};
const _withScopeId = (n) => (pushScopeId("data-v-1d84f660"), n = n(), popScopeId(), n);
const _hoisted_1 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.4",
  d: "M16.8749 13.1875L2.15238 13.1875C0.968775 13.1875 0.00952538 12.2083 0.00952549 11C0.0095256 9.79174 0.968775 8.81251 2.15238 8.81251L16.8749 8.81252L18.9102 11L16.8749 13.1875Z"
}, null, -1));
const _hoisted_2 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("path", { d: "M24 11C24 11.5426 23.8041 12.0844 23.4107 12.5065L15.2679 21.2565C14.4525 22.1323 13.0965 22.1682 12.2377 21.336C11.3839 20.5028 11.3471 19.1168 12.1607 18.2435L18.9006 11L12.1607 3.7565C11.3471 2.88232 11.3823 1.49637 12.2377 0.664086C13.0966 -0.168202 14.4526 -0.132274 15.2679 0.743547L23.4107 9.49355C23.8041 9.91568 24 10.4574 24 11Z" }, null, -1));
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "22",
    viewBox: "0 0 24 22",
    fill: "currentColor",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: normalizeClass($options.arrowIconClass)
  }, _hoisted_3, 2);
}
const ArrowIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-1d84f660"]]);
export {
  ArrowIcon as default
};
//# sourceMappingURL=ArrowIcon.vue.es.js.map
